/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
const getSelectedKeys = (newSelectedKeys: string[]) => {
  //const convertedObject = {};
  let expandedKeys: any = {};
  const outputObject = Object.fromEntries(
    newSelectedKeys.map((element: any) => [element, true])
  );
  for (const [key, value] of Object.entries(outputObject)) {
    expandedKeys[key] = value;
  }
  return expandedKeys;
};
export default getSelectedKeys;
